import Vue from 'vue'
import Vuex from 'vuex'
import homeServer from '@/api/home-server.js'
import createPersistedState from "vuex-persistedstate";
// import { saveState } from '@/assets/js/utils'
// const stateBackup = localStorage.getItem('stateBackup') ? JSON.parse(localStorage.getItem('stateBackup')) : {}

Vue.use(Vuex)

const state =  {
    ACCOUNT: {},
}
const getters = {
    getAccount(state) {
        return state.ACCOUNT
    }
}
const mutations = {
    setAccount(state, value) {
        state.ACCOUNT = value
        // localStorage.setItem('stateBackup', JSON.stringify(state))
        // saveState()
    }
}
const actions = {
    asynclogin({ commit, dispatch }, _this) {
        homeServer.login(_this.ruleForm).then(res => {
            _this.loginLoading = false
            if (res.data && res.data.token) {
                sessionStorage.setItem('token', res.data.token)
                commit('setAccount', _this.ruleForm.account)
                _this.$router.push({
                    path: '/home',
                })
            } else {
                _this.loginErrTip = res.message
            }
        })
    },
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    plugins: [createPersistedState({
        storage: window.sessionStorage,
        // reducer(val) {
        //   return { // 只储存state中的user 
        //     user: val.base
        //   }
        // }
    })]
})
